import { render, staticRenderFns } from "./SuperAdminHeader.vue?vue&type=template&id=1ce63f46&scoped=true&"
import script from "./SuperAdminHeader.vue?vue&type=script&lang=js&"
export * from "./SuperAdminHeader.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminHeader.vue?vue&type=style&index=0&id=1ce63f46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce63f46",
  null
  
)

export default component.exports